import { trash } from "../../icons.js";
import BaseComponent from "../base-component.js";
import {h} from "preact"

class MultipleChoiceQuestionComponent extends BaseComponent {

  responseCollector() {
    let choices = this.props.item.responseDeclaration.choices
    //@type {Array<number>}
    let selectedChoiceIds = []
    if(this.props.item.responseType == "single-bubble" || this.props.item.responseType == "true-false") {
      selectedChoiceIds = this.props.studentResponse?.single_bubble?.choice_id !== undefined ? [this.props.studentResponse?.single_bubble?.choice_id] : []
    } else {
      selectedChoiceIds = this.props.studentResponse?.multiple_bubble?.choice_ids || []
    }

    let updateStudentResponse = (choiceId) => {
      if(this.props.item.responseType == "single-bubble" || this.props.item.responseType == "true-false") {
        let eliminatedIds = this.props.studentResponse?.single_bubble?.eliminated_ids || []
        eliminatedIds = eliminatedIds.filter((id) => id != Number(choiceId))
        this.props.updateStudentResponse({single_bubble: {choice_id: choiceId, eliminated_ids: eliminatedIds}})
      } else {
        let choiceIds = this.props.studentResponse?.multiple_bubble?.choice_ids || []
        let eliminatedIds = this.props.studentResponse?.multiple_bubble?.eliminated_ids || []
        let index = choiceIds.indexOf(choiceId)
        if(index == -1) {
          choiceIds.push(choiceId)
          eliminatedIds = eliminatedIds.filter((id) => id != Number(choiceId))
        } else {
          choiceIds.splice(index, 1)
        }
        this.props.updateStudentResponse({multiple_bubble: {choice_ids: choiceIds, eliminated_ids: eliminatedIds}})
      }
    }

    if(choices) {
      let sortedChoices = choices.sort((a, b) => { return a.ordinal > b.ordinal ? 1 : -1})
      return <div class="response-collector multiple-choice">
        {sortedChoices.map((choice) => {
          let eliminated = false;
          if(this.props.item.responseType == "multiple-bubble") {
            eliminated = this.props.studentResponse?.multiple_bubble?.eliminated_ids?.includes(Number(choice.id)) || false
          } else {
            eliminated = this.props.studentResponse?.single_bubble?.eliminated_ids?.includes(Number(choice.id)) || false
          }

          return <div class={eliminated ? "response eliminated" : "response"} data-choice-id={Number(choice.id)} onClick={() => {updateStudentResponse(choice.id)} }>
            <div class="label">
              <button tabIndex={1} class={`bubble ${selectedChoiceIds.includes(Number(choice.id)) ? "selected" : ""}`} >{choice.identifier}</button>
            </div>
            <div class="answer-container">
              <div class="answer" dangerouslySetInnerHTML={{__html: choice.body}}></div>
            </div>
            <div class="eliminate-button" style={this.props.allowChoiceElimination ? {} : {display: "none"}} dangerouslySetInnerHTML={{__html: trash}} onClick={(e) => {
              e.stopPropagation();
              /** @type {number[]} */
              let eliminatedIds = [];
              if(this.props.item.responseType == "multiple-bubble") {
                eliminatedIds = this.props.studentResponse?.multiple_bubble?.eliminated_ids || []
              } else {
                eliminatedIds = this.props.studentResponse?.single_bubble?.eliminated_ids || []
              }
              let index = eliminatedIds.indexOf(Number(choice.id))
              if(index == -1) {
                eliminatedIds.push(Number(choice.id))
              } else {
                eliminatedIds.splice(index, 1)
              }
              
              if (this.props.item.responseType == "single-bubble" || this.props.item.responseType == "true-false") {
                this.props.updateStudentResponse({single_bubble: {choice_id: selectedChoiceIds[0], eliminated_ids: eliminatedIds}})
              } else {
                this.props.updateStudentResponse({multiple_bubble: {choice_ids: selectedChoiceIds, eliminated_ids: eliminatedIds}})
              }
            }}>
            </div>
          </div>
        })}
      </div>
    }
  }

  render() {
    return(
      this.wrapper(
        this.body(), this.responseCollector()
      )
    );
  }
}

export default MultipleChoiceQuestionComponent 